<template>
  <gc-alert type="success" text>{{ $t('message.success.title') }}</gc-alert>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';
import GcAlert from '@/components/primitives/GcAlert.vue';

export default defineComponent({
  components: {
    GcAlert,
  },
});
</script>
